import { api } from "../index";

export const adminUsers = api.injectEndpoints({
  endpoints: (builder) => ({
    AdminListUsers: builder.query({
      query: ({ filters, page = 1 }) =>
        filters
          ? `/api/v1/organization/users?page=${page}&per_page=10&${filters}`
          : `/api/v1/organization/users?page=${page}&per_page=10`,
      providesTags: ["Users"],
    }),

    AdminGetUser: builder.query({
      query: (userId) => `/api/v1/organization/users/${userId}`,
      providesTags: ["User"],
    }),

    AdminGetUserStats: builder.query({
      query: (userId) => `/api/v1/organization/users/${userId}/stats`,
    }),

    AdminGetUserPosts: builder.query({
      query: ({ userId, page }) =>
        `/api/v1/organization/users/${userId}/posts?page=${page}&per_page=10`,
      providesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
      ],
    }),

    adminListOrganizationPosts: builder.query({
      query: ({ page = 1 }) =>
        `/api/v1/organization/posts?page=${page}&per_page=10`,
      providesTags: ["AdminOrganizationFeed"],
    }),

    adminGetOrganizationPost: builder.query({
      query: (postId) => `/api/v1/organization/posts/${postId}`,
      providesTags: (result, error, postId) => [
        { type: "AdminOrganizationFeed", id: String(postId) },
      ],
    }),

    AdminGetUserLearningTracks: builder.query({
      query: ({ userId, page = 1, perPage = 10 }) =>
        `/api/v1/organization/users/${userId}/learning_tracks/progress?page=${page}&per_page=${perPage}`,
    }),

    AdminGetUserQuizStats: builder.query({
      query: (userId) => `/api/v1/organization/users/${userId}/quiz_stats`,
    }),

    AdminGetUserCompletedCourses: builder.query({
      query: (userId) =>
        `/api/v1/organization/users/${userId}/courses/completed?page=1&per_page=250`,
    }),

    AdminGetUserPostStats: builder.query({
      query: (userId) => `/api/v1/organization/users/${userId}/statistics`,
    }),

    searchUsers: builder.query({
      query: (filters) => ({
        url: `api/v1/organization/users?${filters}`,
        method: "GET",
      }),
    }),

    inviteUser: builder.mutation({
      query: (email) => ({
        url: `/api/v1/organization/users/invite`,
        method: "POST",
        body: { email },
      }),
    }),

    inviteByCSV: builder.mutation({
      query: (body) => ({
        url: `/api/v1/organization/users/invite_by_csv`,
        method: "POST",
        body,
      }),
    }),

    updateUser: builder.mutation({
      query: ({ userId, updates }) => ({
        url: `/api/v1/organization/users/${userId}`,
        method: "PUT",
        body: updates,
      }),
      invalidatesTags: ["Users", "User"],
    }),

    adminLikeEmployeePost: builder.mutation({
      query: ({ userId, postId }) => ({
        url: `/api/v1/organization/users/${userId}/posts/${postId}/likes`,
        method: "POST",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
        "AdminOrganizationFeed",
      ],
    }),

    adminUnlikeEmployeePost: builder.mutation({
      query: ({ userId, postId }) => ({
        url: `/api/v1/organization/users/${userId}/posts/${postId}/likes`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
        "AdminOrganizationFeed",
      ],
    }),

    adminCommentOnEmployeePost: builder.mutation({
      query: ({ userId, postId, body }) => ({
        url: `/api/v1/organization/users/${userId}/posts/${postId}/comments`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
        "AdminOrganizationFeed",
      ],
    }),

    adminLikeEmployeeComment: builder.mutation({
      query: ({ commentId, userId }) => ({
        url: `/api/v1/organization/comments/${commentId}/likes`,
        method: "POST",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
        "AdminOrganizationFeed",
      ],
    }),

    adminUnlikeEmployeeComment: builder.mutation({
      query: ({ commentId, userId }) => ({
        url: `/api/v1/organization/comments/${commentId}/likes`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "AdminEmployeePosts", id: arg.userId },
        "AdminOrganizationFeed",
      ],
    }),
  }),
});

export const {
  useAdminListUsersQuery,
  useAdminGetUserQuery,
  useAdminGetUserStatsQuery,
  useLazyAdminGetUserPostsQuery,
  useLazyAdminListOrganizationPostsQuery,
  useAdminGetOrganizationPostQuery,
  useAdminGetUserPostStatsQuery,
  useAdminGetUserLearningTracksQuery,
  useAdminGetUserQuizStatsQuery,
  useAdminGetUserCompletedCoursesQuery,
  useInviteUserMutation,
  useInviteByCSVMutation,
  useUpdateUserMutation,
  useLazySearchUsersQuery,
  useAdminLikeEmployeePostMutation,
  useAdminUnlikeEmployeePostMutation,
  useAdminCommentOnEmployeePostMutation,
  useAdminLikeEmployeeCommentMutation,
  useAdminUnlikeEmployeeCommentMutation,
} = adminUsers;
